// Dados agregados para o Painel Executivo. Calcula a receita 12m (pipeline em R$)
// de cada projeto a partir das capas (product_cards.vendas).
import { supabase } from './supabase';

interface VendaSaborLike {
  preco_kg?: number;
  volume_mensal?: number[];
}
interface VendasLike {
  preco_kg?: number;
  volume_mensal?: number[];
  por_sabor?: VendaSaborLike[];
}

const soma = (a: number[] | undefined) => (a ?? []).reduce((x, y) => x + (y || 0), 0);

/** Receita bruta 12m por produto (R$), a partir das vendas na capa. */
export async function loadPipeline(orgId: string): Promise<Map<string, number>> {
  const { data } = await supabase
    .from('product_cards')
    .select('product_id, vendas')
    .eq('org_id', orgId);
  const out = new Map<string, number>();
  for (const row of (data ?? []) as { product_id: string; vendas: VendasLike | null }[]) {
    const v = row.vendas ?? {};
    let receita = 0;
    const ps = v.por_sabor ?? [];
    if (ps.length) {
      for (const s of ps) receita += soma(s.volume_mensal) * (s.preco_kg ?? 0);
    } else {
      receita = soma(v.volume_mensal) * (v.preco_kg ?? 0);
    }
    out.set(row.product_id, receita);
  }
  return out;
}
